<small class="text-muted d-flex align-items-center gap-1">
    <i class="bi bi-info-circle text-primary"></i>
    <span>Click on legend items to filter the chart</span>
</small>